import { render, staticRenderFns } from "./ManagePath.vue?vue&type=template&id=3d4627c2"
import script from "./ManagePath.vue?vue&type=script&lang=js"
export * from "./ManagePath.vue?vue&type=script&lang=js"
import style0 from "./ManagePath.vue?vue&type=style&index=0&id=3d4627c2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports